export default __webpack_public_path__ + "static/media/Employees.6d806f15.svg";